/** @format */

import { formatDate } from '@angular/common';
import {
  ErrorMessages,
  LengthError,
  MaxError,
  MinError,
} from '../error-messages';
import { passwordPromptZh } from './password.prompt';

export function errorMessagesZhHKFactory(
  // locale: string,
  format = 'shortDate'
): ErrorMessages {
  return {
    min: (error: MinError) => `請輸入一個大於或等於 ${error.min} 的值。`,
    max: (error: MaxError) => `請輸入小於或等於 ${error.max} 的值。`,
    msg: (s) => s,
    invalid: `輸入不正確`,
    required: `此欄必須填寫`,
    email: `請輸入有效的電郵地址`,
    mobile: `電話號碼無效`,
    url: `網址不正確`,

    password: (error) => {
      return passwordPromptZh(error);

    },
    passwordNotMatched: (error) => '密碼不符',
    minlength: (error: LengthError) =>
      `請輸入至少 ${error.requiredLength} 個字符。`,
    maxlength: (error: LengthError) =>
      `請輸入不超過 ${error.requiredLength} 個字符。`,

    dateRange: (error) =>
      `無效的日期範圍：${error.start} > ${error.end}`,
    dateRangeDays: (error) =>
      `超出日期上限：${error.days} 天`,

    numbersLessThan: (error) => `${error.start}必須小於${error.end}`,
    numbersLessThanEquals: (error) => `${error.start}必須小於或等於${error.end}`,

    matDatepickerMin: (error: MinError) => {
      const formatted = formatDate(error.min, format, 'en');
      return `請輸入 ${formatted ?? error.min}或之後的日期。`;
    },
    matDatepickerMax: (error: MaxError) => {
      const formatted = formatDate(error.max, format, 'en');
      return `請輸入 ${formatted ?? error.max}或之前的日期。`;
    },
  };
}
